import * as React from "react";
import get from "lodash/get";

/**
 * If there is no entity in the list whose key matches the entityId, then
 * we pick the first item in the list (if any).
 *
 * @param entities
 * @param entityId
 * @param key
 * @param selectOption
 */
const useFallback = (entities, entityId, key, selectOption) => {
  React.useEffect(() => {
    if (!entities?.length) {
      selectOption({ value: null });
      return;
    }

    const selectedEntity = entities.find((item) => get(item, key) === entityId);
    if (!selectedEntity) {
      console.warn(
        `[card.useFallback] Could not find pbx/tenant with ${key}='${entityId}'. Falling back to first.`
      );

      selectOption({ value: entities?.[0] });
    }
  }, [entities, entityId, selectOption]);
};

export default useFallback;
